// Keep each field a literal process.env.X expression so build-time define/DefinePlugin can replace it.
export interface RuntimeEnv {
  readonly NODE_ENV: string | undefined;
  readonly REACT_APP_ENV: string | undefined;
  readonly REACT_APP_CYPRESS_TESTING: string | undefined;
  readonly REACT_APP_FUSION_CHARTS_KEY: string | undefined;
  readonly REACT_APP_GIT_SHA: string | undefined;
  readonly REACT_APP_SALES_SECRET: string | undefined;
  readonly REACT_APP_VERSION: string | undefined;
}

export const runtimeEnv: RuntimeEnv = Object.freeze({
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_CYPRESS_TESTING: process.env.REACT_APP_CYPRESS_TESTING,
  REACT_APP_FUSION_CHARTS_KEY: process.env.REACT_APP_FUSION_CHARTS_KEY,
  REACT_APP_GIT_SHA: process.env.REACT_APP_GIT_SHA,
  REACT_APP_SALES_SECRET: process.env.REACT_APP_SALES_SECRET,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION
});
